@if (selected() === null) {
    <h2 [id]="headingId()" class="summary-heading">Suggested actions</h2>
    <fieldset
        class="summary-actions m-0 min-w-0 border-0 p-0"
        [attr.aria-labelledby]="headingId()"
    >
        @for (card of cards(); track card.id) {
            <button
                #actionButton
                qpxButton="unstyled"
                class="summary-action w-full rounded-lg border border-border bg-card p-4 text-left text-card shadow-xs hover:bg-accent"
                [attr.aria-labelledby]="`${headingId()}-${card.id}`"
                [attr.aria-describedby]="`${headingId()}-${card.id}-description`"
                (click)="selectAction(card.id)"
            >
                <span class="summary-action-content">
                    <qpx-hero-icon
                        [name]="card.icon"
                        [context]="card.context"
                        tone="muted"
                        size="md"
                        class="shrink-0"
                        aria-hidden="true"
                    />
                    <span class="flex min-w-0 flex-col">
                        <span
                            qpxBody="card"
                            size="lg"
                            class="font-semibold"
                            [id]="`${headingId()}-${card.id}`"
                            >{{ card.title }}</span
                        >
                        <span
                            qpxBody="secondary"
                            size="md"
                            [id]="`${headingId()}-${card.id}-description`"
                            >{{ card.description }}</span
                        >
                    </span>
                </span>
            </button>
        }
        @if (stackLinks()) {
            <div class="secondary-actions">
                @for (link of secondaryActions(); track link.id) {
                    <ng-container
                        [ngTemplateOutlet]="summaryLink"
                        [ngTemplateOutletContext]="{
                            $implicit: link,
                            compact: true,
                        }"
                    />
                }
            </div>
        } @else {
            @for (link of secondaryActions(); track link.id) {
                <ng-container
                    [ngTemplateOutlet]="summaryLink"
                    [ngTemplateOutletContext]="{
                        $implicit: link,
                        compact: false,
                    }"
                />
            }
        }
        <ng-template #summaryLink let-link let-compact="compact">
            <a
                qpxButton="unstyled"
                [routerLink]="link.target"
                class="summary-action w-full rounded-lg border border-border bg-card p-4 text-left text-card shadow-xs hover:bg-accent"
                [class.compact]="compact"
                [attr.aria-labelledby]="`${headingId()}-${link.id}`"
                [attr.aria-describedby]="`${headingId()}-${link.id}-description`"
            >
                <span class="summary-action-content">
                    <qpx-hero-icon
                        [name]="link.appearance.icon"
                        [context]="link.appearance.context"
                        tone="muted"
                        size="md"
                        class="shrink-0"
                        aria-hidden="true"
                    />
                    <span class="flex min-w-0 flex-col">
                        <span
                            qpxBody="card"
                            size="lg"
                            class="title font-semibold"
                            [id]="`${headingId()}-${link.id}`"
                            >{{ link.title }}</span
                        >
                        <span
                            qpxBody="secondary"
                            size="md"
                            class="description"
                            [id]="`${headingId()}-${link.id}-description`"
                            >{{ link.description }}</span
                        >
                    </span>
                </span>
            </a>
        </ng-template>
    </fieldset>
} @else {
    <qpx-quippy-suggested-questions
        [headingId]="headingId()"
        heading=""
        [ariaLabel]="detailTitle()"
        [questions]="detailQuestions()"
        [resetKey]="selected()"
        [allowCategoryFilter]="selected() === 'ask'"
        [compactRows]="true"
        (questionSelected)="questionSelected.emit($event)"
    >
        <div suggestionHeading class="flex min-w-0 items-center gap-2">
            <button
                #backButton
                qpxButton="unstyled"
                class="flex shrink-0 items-center justify-center rounded p-1"
                aria-label="Close suggested action"
                (click)="backToSummary()"
            >
                <ng-icon qpx name="lucideX" size="sm" />
            </button>
            <h2
                [id]="headingId()"
                class="m-0 truncate text-base font-semibold text-foreground"
            >
                {{ detailTitle() }}
            </h2>
        </div>
    </qpx-quippy-suggested-questions>
}
